import React from 'react';
import { useBooking } from './BookingModal';

// Restrained, editorial buttons — squared, no shadow, no fill gimmicks.
const VARIANTS = {
  primary:
    'bg-primary-800 text-cream hover:bg-primary-700 border border-primary-800',
  soft:
    'bg-primary-500 text-cream hover:bg-primary-600 border border-primary-500',
  outline:
    'bg-transparent text-primary-800 border border-primary-300 hover:border-primary-800',
  light:
    'bg-cream text-primary-900 hover:bg-white border border-cream',
  ghost:
    'bg-transparent text-secondary-800 border-b border-secondary-400 hover:border-secondary-900 rounded-none px-0',
};

const SIZES = {
  sm: 'px-6 py-3 text-sm',
  md: 'px-8 py-4 text-[15px]',
  lg: 'px-10 py-5 text-base',
};

const BookCall = ({
  variant = 'primary',
  size = 'md',
  className = '',
  children = 'Request a conversation',
}) => {
  const { open } = useBooking();
  const isGhost = variant === 'ghost';
  return (
    <button
      type="button"
      onClick={open}
      className={`group inline-flex items-center justify-center whitespace-nowrap font-medium tracking-wide transition-colors duration-300 ${
        isGhost ? 'py-2' : 'rounded'
      } ${VARIANTS[variant]} ${isGhost ? '' : SIZES[size]} ${className}`}
    >
      {children}
    </button>
  );
};

export default BookCall;
